// extracted by mini-css-extract-plugin
module.exports = {"root":"TheFooter_root_1XXPd","link":"TheFooter_link_32I8y","copyright":"TheFooter_copyright_1_3ou","spinAround":"TheFooter_spinAround_61fbG"};